"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StudentSignDocumentController = /** @class */ (function () {
    function StudentSignDocumentController($stateParams, UserService, FlashService) {
        this.$stateParams = $stateParams;
        this.UserService = UserService;
        this.FlashService = FlashService;
        this.userRole = "student";
        this.handleSignatureAdded = this.handleSignatureAdded.bind(this);
        this.handleError = this.handleError.bind(this);
        var currentUser = UserService.getCurrentUser();
        this.documentId = parseInt($stateParams.documentId, 10);
        this.userId = currentUser.id;
    }
    StudentSignDocumentController.prototype.handleSignatureAdded = function (signatureData) {
        var fieldId = signatureData.document_field_id;
        this.FlashService.setMessage({
            type: "success",
            message: "Signature for field ".concat(fieldId, " saved successfully!"),
        });
    };
    StudentSignDocumentController.prototype.handleError = function (error) {
        this.FlashService.setMessage({
            type: "error",
            message: error.message || "An error occurred while processing your signature.",
        });
    };
    StudentSignDocumentController.$inject = [
        "$stateParams",
        "UserService",
        "FlashService",
    ];
    return StudentSignDocumentController;
}());
exports.default = StudentSignDocumentController;
